<mat-card appearance="outlined" class="default-card">
    <mat-card-header>
        <mat-card-title>Ajout d'un dossier</mat-card-title>
    </mat-card-header>
    <mat-card-content>
        <div class="container">
            @for (attribute of attributesSystem; track attribute.id) {
                <!-- Affiche tous les attributs système -->
                @if (attribute.propertyCode !== BOX_ID && attribute.propertyCode !== VIEW_ID) {
                    <app-attribute
                        [readonly]="false"
                        class="attributes-value"
                        [attributeDefinition]="attribute"
                        [value]="attribute.defaultValue"
                        (valueUpdated)="updateAttribute(attribute, $event)"></app-attribute>
                } @else if (attribute.propertyCode === BOX_ID) {
                    <div class="attributes-value">
                        <div class="form-item">
                            <mat-form-field>
                                <mat-label>
                                    {{ attribute.mandatory === true ? attribute.header + '*' : attribute.header }}
                                </mat-label>
                                <mat-select [disabled]="false" (selectionChange)="updateAttribute(attribute, $event.value)">
                                    @for (boxGroup of boxGroupInfo; track boxGroup.id) {
                                        <mat-optgroup [label]="boxGroup.name">
                                            @for (box of boxGroup.boxes; track box.id) {
                                                <mat-option [value]="box.id">
                                                    {{ box.name }}
                                                </mat-option>
                                            }
                                        </mat-optgroup>
                                    }
                                </mat-select>
                            </mat-form-field>
                        </div>
                    </div>
                }
            }
            @for (attribute of attributesCustom; track attribute.id) {
                <!-- Affiche tous les attributs personnalisés -->
                <app-attribute
                    [readonly]="false"
                    class="attributes-value"
                    [attributeDefinition]="attribute"
                    [value]="data.folder.customAttributes[attribute.propertyCode]"
                    (valueUpdated)="updateAttribute(attribute, $event)"></app-attribute>
            }

            <ngx-spinner name="add-folder-spinner" [fullScreen]="false" type="timer" size="medium"></ngx-spinner>
        </div>
    </mat-card-content>
    @if (!!attributesCustom && !!attributesSystem) {
        <mat-card-actions>
            <button mat-stroked-button class="accent-button" (click)="cancel()">Annuler</button>
            <button mat-raised-button class="accent-button" (click)="validate()" [disabled]="!isValid()">Enregistrer</button>
        </mat-card-actions>
    }
</mat-card>
